export default axiosInstance => ({
  /**
   * get Values Mirakl
   * @return {Promise} retour axios
   */
  async listMiraklValues(params) {
    return await axiosInstance.get("/mirakl_values", { params });
  },

  /**
   * add Values Mirakl
   * @return {Promise} retour axios
   */
  async addValues(params) {
    return await axiosInstance.post("/mirakl_values", { ...params });
  },

  /**
   * post Values csv
   * @return {Promise} retour axios
   */
  async importValuesCsv(params) {
    let formData = new FormData();
    formData.append("file", params);
    return await axiosInstance.post("/mirakl_values/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  /**
   * Downloads the list of Mirakl values in csv format
   * @return {Promise} retour axios
   */
  async downloadValuesAsCsv() {
    return await axiosInstance.get("/mirakl_values/export");
  }
});
